<div class="button-outer">
  <div class="button-wrapper">
    <ion-button data-cy="fileCopyDecreaseBtn" class="counter-icon" (click)="decrease()" [attr.aria-label]="('DECREASE' | translate) + ' ' + ('COPIES' | translate)">
      <ion-icon slot="icon-only" name="remove" aria-hidden="true"></ion-icon>
    </ion-button>
  </div>
</div>
<span class="counter-value">{{ counterValue }}</span>
<div class="button-outer">
  <div class="button-wrapper">
    <ion-button data-cy="fileCopyIncreaseBtn" class="counter-icon" (click)="increase()" [attr.aria-label]="('INCREASE' | translate) + ' ' + ('COPIES' | translate)">
      <ion-icon slot="icon-only" name="add" aria-hidden="true"></ion-icon>
    </ion-button>
  </div>
</div>